// extracted by mini-css-extract-plugin
var _1 = "uWgtINagzJNXDfsBw1g6";
var _2 = "JdzN7fc8OrprqZjHZUib";
var _3 = "Zbp5Oed37DU2Xmi5WAoo";
var _4 = "X8monNl0YWCDKnpftI8K";
var _5 = "pOTQE0XF5I6BCqoaaIrg";
var _6 = "LsUjxpvpev8JnVzPO6jC";
var _7 = "FuSrxpuo8hVNjCk2a9w9";
var _8 = "I1vr9LJKycs2ucIVQ_OC";
export { _1 as "background", _2 as "center", _3 as "container", _4 as "isActive", _5 as "isSmall", _6 as "left", _7 as "right", _8 as "textContainer" }
